<script setup>
import { ref } from 'vue';
import { useAlert } from 'dashboard/composables';
import API from 'dashboard/api/talkviaCreditDashboard';
const props = defineProps({
  item: { type: Object, required: true },
  period: { type: Object, required: true },
});
const cpf = ref(null);
const loading = ref(false);
const toggle = async () => {
  if (cpf.value) {
    cpf.value = null;
    return;
  }
  loading.value = true;
  try {
    const { data } = await API.revealCpf({
      ...props.period,
      source: props.item.source,
      record_id: props.item.record_id,
    });
    if (!data.cpf) {
      useAlert('CPF completo não disponível neste registro.');
      return;
    }
    cpf.value = data.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  } catch {
    useAlert('Não foi possível revelar o CPF.');
  } finally {
    loading.value = false;
  }
};
</script>

<template>
  <span class="inline-flex items-center gap-2 text-xs">
    <span>{{ cpf || item.cpf || 'CPF não informado' }}</span>
    <button
      type="button"
      :disabled="loading"
      :aria-label="cpf ? 'Ocultar CPF' : 'Revelar CPF'"
      :title="cpf ? 'Ocultar CPF' : 'Revelar CPF'"
      class="inline-flex rounded p-1 hover:bg-n-alpha-2"
      @click="toggle"
    >
      <span
        class="size-4"
        :class="
          loading
            ? 'i-lucide-loader-circle animate-spin'
            : cpf
              ? 'i-lucide-eye-off'
              : 'i-lucide-eye'
        "
      />
    </button>
  </span>
</template>
